import { csx } from '@vtex/admin-ui'

const styles = {
  iconContainer: csx({
    minWidth: '2.75rem',
    minHeight: '2.75rem',
    color: '$action.main.secondary',
    background: '$info',
    borderRadius: 4,
  }),
  rounded: csx({
    borderRadius: '50%',
  }),
}

export default styles
